"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRKIRegistrations = void 0;
const moment_1 = __importDefault(require("moment"));
const getRKIRegistrations = (userDetails) => {
    return (userDetails === null || userDetails === void 0 ? void 0 : userDetails.rkiRegistrations)
        ? userDetails.rkiRegistrations
            .filter((registration) => {
            const slettetDato = registration.SlettetDato &&
                (0, moment_1.default)(registration.SlettetDato, 'DDMMYYYY');
            return (0, moment_1.default)().isBefore(slettetDato);
        })
            .filter((registration) => !userDetails.rkiDeletions ||
            !userDetails.rkiDeletions.some((deletion) => deletion.debtor.debtorNumber ===
                registration.Debitor.attributes.debitorNr))
        : null;
};
exports.getRKIRegistrations = getRKIRegistrations;
//# sourceMappingURL=helpers.js.map